import React, { useEffect, useState } from "react";
import ReportDialogContent from "./ReportDialogContent";

import "../../css/AppDialog.css";
import { UseJsonApi } from "../../jsonApi";
import ReportSummaryDialogContent from "./ReportSummaryDialogContent";
import { ReportInfo } from "./FormDataTypes";


export interface AppDialogProps {
  isOpen: boolean;
  onDialogClose?: () => void;
}

const ReportMainDialogContent : React.FC<AppDialogProps> = ({isOpen, onDialogClose}) => {
    
    const {} = UseJsonApi();

    const [editMode, setEditMode] = useState<boolean>(true);
    const [reportData, setReportData] = useState<ReportInfo>({title:"", startDate:"", endDate:"", description:"", surveys: [], activities:[], agendas:[], finished:false, thumbnailPath:""});
    const [summary, setSummary] = useState<string|null>(null);

    const ToSummaryPage = () => {
        setEditMode(false);
    };

    const OnBackClicked = () => {
        setEditMode(true);
    };

    return (
        <>
            {editMode ? 
                <ReportDialogContent isOpen={true} ToSummary={ToSummaryPage} reportData={reportData} setReportData={setReportData}/> : 
                <ReportSummaryDialogContent isOpen={true} OnBackClicked={OnBackClicked} reportData={reportData} summary={summary} setSummary={setSummary}/>
            }
        </>
    );
}

export default ReportMainDialogContent;